<template>
  <div id="visitObject">
    <el-dialog :visible.sync="showApproval">
      <el-form :model="reviewForm" label-width="auto" :rules="rules" ref="approvaFormRef">
        <el-form-item label="审批结果" prop="approvalResult">
          <el-radio-group v-model="reviewForm.approvalResult">
            <el-radio :label="-1" :value="-1">不通过</el-radio>
            <el-radio :label="1" :value="1">通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审批意见" prop="approvalComment">
          <el-input
            v-model="reviewForm.approvalComment"
            :rows="2"
            type="textarea"
            placeholder="请输入审批意见"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onApproval()">确 定</el-button>
      </span>
    </el-dialog>
    <el-form inline size="small">
      <el-form-item label="姓名">
        <el-input v-model="searchForm.name" placeholder="请输入姓名" clearable />
      </el-form-item>
      <el-form-item label="身份证号码">
        <el-input v-model="searchForm.idNumber" placeholder="请输入身份证号码" clearable />
      </el-form-item>
      <el-form-item label="单位名称">
        <el-input v-model="searchForm.companyName" placeholder="请输入单位名称" clearable />
      </el-form-item>
      <el-form-item label="联系方式">
        <el-input v-model="searchForm.contact" placeholder="请输入联系方式" clearable />
      </el-form-item>
      <el-form-item label="审批结果">
        <el-select v-model="searchForm.approvalResult" clearable>
          <el-option label="未审核" :value="0" />
          <el-option label="通过" :value="1" />
          <el-option label="不通过" :value="-1" />
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期">
        <el-date-picker
          v-model="searchForm.startDate"
          type="date"
          placeholder="选择开始日期"
          value-format="yyyy-MM-dd"
          cllearable
        />
      </el-form-item>
      <el-form-item label="结束日期">
        <el-date-picker
          v-model="searchForm.endDate"
          type="date"
          placeholder="选择结束日期"
          value-format="yyyy-MM-dd"
          cllearable
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">
          查 询
        </el-button>
        <el-button type="primary" icon="el-icon-download" @click="handleExport">
          导出
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
      id="xls-table"
      ref="mainTableRef"
      :data="mainTable.list"
      row-key="bid"
      default-expand-all
      :cell-style="{padding: '6px'}"
      :header-cell-style="{background: '#f8f8f9'}"
      @row-click="handleRowClick"
    >
      <el-table-column prop="name" label="姓名" width="90" />
      <el-table-column prop="sex" label="性别" width="60" />
      <el-table-column prop="jobCategory" label="工种" width="90" align="center" />
      <el-table-column prop="visitTime" label="参访时间" width="110" align="center" />
      <el-table-column prop="idNumber" label="身份证号" width="180" align="center" />
      <el-table-column prop="companyName" label="工作单位" width="150" align="center" />
      <el-table-column prop="contact" label="联系方式" width="150" align="center" />
      <el-table-column prop="visitReason" label="参访原因" width="150" align="center" />
      <el-table-column prop="applySignature" label="廉洁承诺申请签名" width="140" align="center">
        <template slot-scope="scope">
          <el-image
            :src="`${BASEURL}/files/${scope.row.applySignature}`"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="申请日期" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.createTime ? scope.row.createTime.split(' ')[0] : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="approvalResult" label="审批结果" width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.approvalResult === 0" type="info">未审批</el-tag>
          <el-tag v-if="scope.row.approvalResult === 1" type="success">通过</el-tag>
          <el-tag v-if="scope.row.approvalResult === -1" type="danger">不通过</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="approvalComment" label="审批意见" width="150" align="center" />
      <el-table-column prop="edit" label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleApproval(scope.row)">
            审核
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :total="mainTable.total"
      :current-page="searchForm.pageNum"
      :page-size="searchForm.pageSize"
      :page-sizes="[10, 15, 20]"
      layout="total, sizes, prev, pager, next, jumper"
      background
      @current-change="pageNumChange"
      @size-change="pageSizeChange"
    />
  </div>
</template>

<script>
import { getVisitApply, approvalVisitApply, visitOutput } from '@/api/medicine/filing.js'
export default {
  name: 'filingRecord',
  data () {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
      },
      mainTable: {
        total: 0,
        list: []
      },
      BASEURL: window.g.BASE_URL,
      showApproval: false,
      reviewForm: {},
      rules: {
        approvalResult: [
          { required: true, message: '请选择审批结果', trigger: 'blur' },
        ],
        approvalComment: [
          { required: true, message: '请输入审批意见', trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    this.getMainList()
  },
  methods: {
    getMainList() {
      const loadingInstance = this.$loading({
        fullscreen: true,  // 是否全屏
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      getVisitApply({
        ...this.searchForm,
        type: 3, // 1: 药品； 2：医用耗材; 3：设备
      }).then((res) =>{
        this.mainTable = res
      }).finally(() => {
        loadingInstance.close()
      })
    },
    handleRowClick (row, col, event) {
      this.$refs.mainTableRef.toggleRowExpansion(row)
    },
    pageNumChange (pageNum) {
      this.searchForm.pageNum = pageNum
      this.getMainList()
    },
    pageSizeChange (pageSize) {
      this.searchForm.pageSize = pageSize
      this.pageNumChange(1)
    },
    handleSearch () {
      this.pageNumChange(1)
    },
    handleApproval(row) {
      this.showApproval = true
      this.reviewForm = {
        id: row.id,
      }
    },
    onApproval() {
      console.log(this.reviewForm)
      this.$refs.approvaFormRef.validate(async (valid) => {
        if (valid) {
          await approvalVisitApply(this.reviewForm)
          // this.$message.success('审批成功')
          this.showApproval = false
          this.getMainList()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async handleExport() {
      const res = await visitOutput({
        ...this.searchForm,
        type: 3, // 1: 药品； 2：医用耗材; 3：设备
      });
      const url = URL.createObjectURL(res);
      const link = document.createElement("a");
      link.href = url;
      link.download = `设备申请记录.xlsx`;
      link.click();
      URL.revokeObjectURL(res);
    },
  }
}
</script>

<style scoped>

</style>
